import { render, staticRenderFns } from "./MtProductInfoSubTable.vue?vue&type=template&id=a559e722&scoped=true&"
import script from "./MtProductInfoSubTable.vue?vue&type=script&lang=js&"
export * from "./MtProductInfoSubTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a559e722",
  null
  
)

export default component.exports